import cloneDeep from 'lodash.clonedeep';
import { put, PutEffect, select, SelectEffect } from 'redux-saga/effects';

import { DeleteMultipleElementsByIdAction, updateScribe } from 'js/actionCreators/scribeActions';
import { ExistingScribeModel } from 'js/types';

import { getScribeById } from '../selectors';

export function* deleteMultipleElementsById({
  elements: elementIds,
  scribeId
}: DeleteMultipleElementsByIdAction): Generator<SelectEffect | PutEffect, void, ExistingScribeModel | undefined> {
  const activeScribe = yield select(getScribeById, scribeId);

  if (!activeScribe) return;

  const newActiveScribe = cloneDeep(activeScribe);

  newActiveScribe.elements = newActiveScribe.elements.filter(element => !elementIds.includes(element.id));
  newActiveScribe.scenes.forEach(scene => {
    scene.elementIds = scene.elementIds.filter(elId => !elementIds.includes(elId));
  });

  yield put(updateScribe(newActiveScribe));
}
